<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="faltosos-vacinas-0-15anos"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :vacinasRegistradas="vacinasRegistradas"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'Faltosos0a15anos',
  metaInfo: {
    title: '0 - 15 anos',
    titleTemplate: null,
  },
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      cadastrosOriginais: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      disabledRed: false,
      disabledGreen: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    async vacinasPorCidadao() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          this.nomeProfissional = user.data.nome
          //pega a equipe do acs
          let equipe = await this.$api.get(
            '/app/equipe/' + this.cod_ibge + '/' + user.data.nu_ine
          )
          if (equipe) {
            this.nomeEquipe = equipe.data.no_equipe
          }
          let response = await this.$api.post(
            '/app/faltosos-vacinas-0-15-anos/profissional',
            {
              co_ibge: this.cod_ibge,
              cpf: user.data.cpf,
            }
          )
          this.cadastrosOriginais = response.data
          this.cadastros = response.data
          this.total_de_registros_da_tabela = response.data.length
          this.filtros(true, false)
          this.setRed = true
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    formatarIdade(idade) {
      if (idade == 0 || idade == 1) {
        return idade + ' mês'
      } else {
        return idade + ' meses'
      }
    },
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        this.nomeProfissional,
        ''
      )
    },
    async init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      await this.vacinasPorCidadao()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
